import vmClient from 'app/services/vmClient';
import { ISentence, Sentence } from 'app/constants/schemas/Sentence';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';

export interface IVocabListSentence extends IEntity {
  attributes: {
    id: EntityStringId;
  };
  associations: {
    sentence: ISentence;
  };
}

export type VocabListSentence = Entity<IVocabListSentence>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VocabListSentence: IEntityType<IVocabListSentence> = vmClient.defineClass({
  typeName: 'VocabListSentence',
  version: 1,
  lockable: true,
  persisted: true,
  attributes: {},
  associations: {
    sentence: {
      type: Sentence,
      notNull: true,
      shared: true,
    },
  },
});
